import { render, staticRenderFns } from "./ResourceDataTableNew.vue?vue&type=template&id=fcb8012a&scoped=true"
import script from "./ResourceDataTableNew.vue?vue&type=script&lang=ts"
export * from "./ResourceDataTableNew.vue?vue&type=script&lang=ts"
import style0 from "./ResourceDataTableNew.vue?vue&type=style&index=0&id=fcb8012a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb8012a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcb8012a')) {
      api.createRecord('fcb8012a', component.options)
    } else {
      api.reload('fcb8012a', component.options)
    }
    module.hot.accept("./ResourceDataTableNew.vue?vue&type=template&id=fcb8012a&scoped=true", function () {
      api.rerender('fcb8012a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/ResourceDataTableNew.vue"
export default component.exports